import React from 'react';
import { Link } from 'react-router-dom';
import { Navbar, Nav, OverlayTrigger, Tooltip } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import '../styles/MenuIconBar.css';

const MenuIconBar = ({
  onAddDocument,
  onOpenDocument,
  onSaveDocument,
  onPrint,
  onCapitalize,
  onLowercase,
  onUppercase,
  onInverseWord,
  onInverseCharacters,
  onWordWrap,
}) => {
  const tip = (text) => (props) => (
    <Tooltip id="button-tooltip" {...props}>{text}</Tooltip>
  );

  return (
    <Navbar bg="light" expand>
      <Nav>
        <OverlayTrigger placement="bottom" overlay={tip('New Document')}>
          <Nav.Link onClick={onAddDocument}><i className="bi bi-file-earmark-plus" /></Nav.Link>
        </OverlayTrigger>

        <OverlayTrigger placement="bottom" overlay={tip('Open Document')}>
          <Nav.Link onClick={onOpenDocument}><i className="bi bi-folder2-open" /></Nav.Link>
        </OverlayTrigger>

        <OverlayTrigger placement="bottom" overlay={tip('Save')}>
          <Nav.Link onClick={onSaveDocument}><i className="bi bi-save" /></Nav.Link>
        </OverlayTrigger>

        <OverlayTrigger placement="bottom" overlay={tip('Print')}>
          <Nav.Link onClick={onPrint}><i className="bi bi-printer" /></Nav.Link>
        </OverlayTrigger>

        <Nav.Item><hr className="d-inline-block mx-2 vertical-separator" /></Nav.Item>

        <OverlayTrigger placement="bottom" overlay={tip('Clean text in Text Cleaner')}>
          <Nav.Link as={Link} to="/text-cleaner">
            <i className="bi bi-stars" />
          </Nav.Link>
        </OverlayTrigger>

        <OverlayTrigger placement="bottom" overlay={tip('Word Wrap')}>
          <Nav.Link onClick={onWordWrap}><i className="bi bi-text-wrap" /></Nav.Link>
        </OverlayTrigger>

        <Nav.Item><hr className="d-inline-block mx-2 vertical-separator" /></Nav.Item>

        <OverlayTrigger placement="bottom" overlay={tip('Capital Case')}>
          <Nav.Link onClick={onCapitalize}><i className="bi bi-type" /></Nav.Link>
        </OverlayTrigger>

        <OverlayTrigger placement="bottom" overlay={tip('Upper Case')}>
          <Nav.Link onClick={onUppercase}><i className="bi bi-alphabet-uppercase" /></Nav.Link>
        </OverlayTrigger>

        <OverlayTrigger placement="bottom" overlay={tip('Lower Case')}>
          <Nav.Link onClick={onLowercase}><i className="bi bi-alphabet" /></Nav.Link>
        </OverlayTrigger>

        <OverlayTrigger placement="bottom" overlay={tip('Inverse Word')}>
          <Nav.Link onClick={onInverseWord}><i className="bi bi-arrow-left-right" /></Nav.Link>
        </OverlayTrigger>

        <OverlayTrigger placement="bottom" overlay={tip('Inverse Characters')}>
          <Nav.Link onClick={onInverseCharacters}><i className="bi bi-arrow-clockwise" /></Nav.Link>
        </OverlayTrigger>
      </Nav>
    </Navbar>
  );
};

export default MenuIconBar;
